import { el, mount, unmount } from 'redom';

import { stringToSVG } from 'utilities';
import { preventPropogation } from 'utilities/dom';

import fullscreenElementSizenIconString from 'assets/images/page-editor-expand-icon.svg?raw';
import resetElementSizeIconString from 'assets/images/page-editor-restore-icon.svg?raw';

const fullscreenElementSizenIcon = stringToSVG(fullscreenElementSizenIconString);
const resetElementSizeIcon = stringToSVG(resetElementSizeIconString);

class ElementResizeControl {

  constructor(target) {

    this.fullscreenOn = false;
    this.target = target;

    this.boundHandleExpandElementButtonClick = this.handleExpandElementButtonClick.bind(this);
    this.boundHandleResetElementSizeButtonClick = this.handleResetElementSizeButtonClick.bind(this);

    this.fullscreenElementSizenButton = el('button.fullscreen-element-size', [fullscreenElementSizenIcon.cloneNode(true)]);
    this.resetElementSizeButton = el('button.reset-element-size', [resetElementSizeIcon.cloneNode(true)]);

    this.el = el('.element-screen-resize-control-main');

  }

  setTarget(target) {
    this.target = target;
  }

  onmount() {

    this.registerEventHandlers();
    this.initialize();

  }

  initialize() {

    if (this.fullscreenOn === true) {
      mount(this.el, this.resetElementSizeButton);
    } else {
      mount(this.el, this.fullscreenElementSizenButton);
    }

  }

  onunmount() {
    this.fullscreenElementSizenButton.removeEventListener('click', this.boundHandleExpandElementButtonClick);
    this.fullscreenElementSizenButton.removeEventListener('dblclick', preventPropogation);
    this.resetElementSizeButton.removeEventListener('click', this.boundHandleResetElementSizeButtonClick);
    this.resetElementSizeButton.removeEventListener('dblclick', preventPropogation);
    this.target = null;
  }

  registerEventHandlers() {

    this.fullscreenElementSizenButton.addEventListener('click', this.boundHandleExpandElementButtonClick);
    this.fullscreenElementSizenButton.addEventListener('dblclick', preventPropogation);

    this.resetElementSizeButton.addEventListener('click', this.boundHandleResetElementSizeButtonClick);
    this.resetElementSizeButton.addEventListener('dblclick', preventPropogation);

  }

  async displayElementInFullscreen() {

    const elementResizeControl = this;

    try {

      this.fullscreenOn = true;

      unmount(this.el, this.fullscreenElementSizenButton);
      mount(this.el, this.resetElementSizeButton);

      await this.target.requestFullscreen();

      document.addEventListener('fullscreenchange', function fullscreenChangeHandler(event) {

        if (document.fullscreenElement !== null) {
          return;
        }

        document.removeEventListener('fullscreenchange', fullscreenChangeHandler);
        elementResizeControl.displayElementInOriginalPositionSoft();
        const fullscreenOffEvent = new CustomEvent('fullscreen-off');
        elementResizeControl.target.dispatchEvent(fullscreenOffEvent);

      });

      const fullscreenOffEvent = new CustomEvent('fullscreen-on');
      this.target.dispatchEvent(fullscreenOffEvent);

    } catch (exception) {

      console.log(exception);

    }

  }

  displayElementInOriginalPositionSoft() {

    this.fullscreenOn = false;

    unmount(this.el, this.resetElementSizeButton);
    mount(this.el, this.fullscreenElementSizenButton);

  }

  async displayElementInOriginalPosition() {

    this.displayElementInOriginalPositionSoft();

    await document.exitFullscreen();

    const fullscreenOffEvent = new CustomEvent('fullscreen-off');
    this.target.dispatchEvent(fullscreenOffEvent);

  }

  handleExpandElementButtonClick(event) {

    event.stopPropagation();

    this.displayElementInFullscreen();

  }

  handleResetElementSizeButtonClick(event) {

    event.stopPropagation();

    this.displayElementInOriginalPosition();

  }

  toggle() {

    if (this.fullscreenOn === true) {
      this.displayElementInOriginalPosition();
    } else {
      this.displayElementInFullscreen();
    }

  }

}

export default ElementResizeControl;